import {
  AnimaticLabel,
  AnimaticPrimitiveState,
  LabelConfig,
  LabelState,
  SummaryConfig,
} from '@repo/sdk/models/components';

import { getActiveState } from '@/features/equipment-browser/conditional-evaluator/get-active-state';

import { LabelConfigMap } from './types';

export const getAnimaticConfigs = (
  equipment?: SummaryConfig
): {
  activeAnimaticState: AnimaticPrimitiveState | undefined;
  labelConfigs: LabelConfigMap;
} => {
  if (!equipment) {
    return {
      activeAnimaticState: undefined,
      labelConfigs: {},
    };
  }

  const animaticStates = equipment.animatic.primitive.states;
  const labels = equipment.animatic.labels ?? [];

  // Get the active animatic state which contains the active animatic config
  const activeAnimaticState = getActiveState<AnimaticPrimitiveState>({
    states: animaticStates,
  });

  // Get the active label configs
  const labelConfigs: { [key: string]: LabelConfig } = {};
  labels.forEach((label: AnimaticLabel) => {
    const activeLabelState = getActiveState<LabelState>({
      states: label.states,
    });
    if (activeLabelState) {
      labelConfigs[label.name] = activeLabelState.config;
    }
  });

  return {
    activeAnimaticState,
    labelConfigs,
  };
};
